export default __webpack_public_path__ + "static/edit-4d2f22b4cdd047b3c25dd0458763bfd4.png";